module.exports = __webpack_public_path__ + "by.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/by.svg
// module id = 473
// module chunks = 0